jQuery_T4NT(document).ready(function($) {

     /**
     * Variant selection changed
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
	    //console.log( variant );
	  });

});

/*
====================================================================
    Add Policy Checkbox to Checkout Page
====================================================================
*/

function isCheckoutPage() {
  //check if main#checkout-main exists
  const mainExists = document.querySelector("main#checkout-main") !== null;
  const checkouts = window.location.pathname.includes("checkouts");
  return mainExists && checkouts;
}

/**
 * Inserts a new div with specified text before the div that contains the button with ID 'checkout-pay-button'.
 * @param {string} textContent - The text or HTML content to be added in the new div.
 * @returns {void}
 */
function addElemBeforeCheckoutButton(textContent) {
  // Get the button element by ID
  const checkoutButton = document.getElementById("checkout-pay-button");

  // Check if the button element exists
  if (checkoutButton) {
    // Get the parent div of the checkout button
    const buttonParentDiv = checkoutButton.parentNode;

    // Create the new div element
    const newDiv = document.createElement("div");
    newDiv.innerHTML = textContent;

    // Insert the new div before the parent div
    buttonParentDiv.parentNode.insertBefore(newDiv, buttonParentDiv);
  } else {
    console.error('Button with ID "checkout-pay-button" not found.');
  }
}

function isPolicyCheckboxChecked() {
  const checkbox = document.getElementById("mbtek-policy-checkbox");
  return checkbox && checkbox.checked;
}

/*
 * Toggles the checkbox with ID 'mbtek-policy-checkbox'.
 * @returns {void}
 */
function togglePolicyCheckbox() {
  console.log("Toggling policy checkbox...");
  const checkbox = document.getElementById("mbtek-policy-checkbox");
  if (checkbox) {
    checkbox.checked = !checkbox.checked;
  } else {
    console.error('Checkbox with ID "mbtek-policy-checkbox" not found.');
  }
}

// When HTML loads completely
document.addEventListener("DOMContentLoaded", function () {
  console.log("loading custom.js");
  // Check if the page is the checkout page
  if (isCheckoutPage()) {
    // Add a new div before the checkout button
    addElemBeforeCheckoutButton(`
    <div>
        <input 
            type="checkbox" id="mbtek-policy-checkbox" name="mbtek-policy-checkbox" required style="
            display: inline-block;height: 1.2rem;width: 1.2rem;pointer-events: all !important;
            border: 1px solid #ff6700;padding: 0.6rem;cursor: pointer;"
            value="0"
            onclick="togglePolicyCheckbox()"
            >
            <label for="mbtek-policy-checkbox" style="cursor: pointer;pointer-events: all !important;"
                onclick="togglePolicyCheckbox()"
            >
            By checking this box, you agree to our shipping, return and refund product policy. 
            To read the policies, 
            <a href="https://www.mbtek.com/pages/shipping-refund-policy" target="_blank">
                click here
            </a>
        </label>
    </div>
    `);

    // After inserting, prevent submission if the checkbox is not policy checked
    const form = document.querySelector("#checkout-main form");

    const paymentButton = document.querySelector("#checkout-pay-button");

    let preventSubmitHandler = function (event) {
      if (!isPolicyCheckboxChecked()) {
        event.preventDefault();
        alert(
          "Please agree to our shipping, return and refund product policy before continuing."
        );
      }
    };

    if (form) {
      form.addEventListener("submit", preventSubmitHandler);
    } else {
      console.error("Checkout Form not found.");
    }

    if (paymentButton) {
      paymentButton.addEventListener("click", preventSubmitHandler);
    } else {
      console.error("Payment Button not found.");
    }
  }
});

// Prevent submitting of form if checkbox is not checked
document.addEventListener("DOMContentLoaded", function () {});
